import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

import "../styles/login.css";

export default function Login() {
  const navigate = useNavigate();
  function handleChange(e) {
    const inputValue = e.value;
    console.log(inputValue);
  }

  function togglePassword(e) {
    const passwordField = document.getElementById("passwordInput");
    const checked = e.target.checked;
    if (checked) {
      passwordField.type = "text";
    } else {
      passwordField.type = "password";
    }
  }
  async function requestLogin(e) {
    e.preventDefault();
    const userId = e.target.name.value;
    const submitBtn = document.getElementById("submit-btn");
    submitBtn.textContent = "Verifying...";
    submitBtn.disabled = true;

    try {
      await axios.post(
        "https://admin-node-api.amanueltesfaye55.workers.dev/admin/auth/request",
        { userId },
      );
      submitBtn.textContent = "Request";
      submitBtn.disabled = false;
      alert("Check Telegram");
    } catch (err) {
      const formLog = document.getElementById("form-log");
      formLog.textContent = "Access Denied";
      submitBtn.textContent = "Request";
      submitBtn.disabled = false;
      //console.log(err);
      //alert(err);
    }
  }
  const token = new URLSearchParams(window.location.search).get("token");
  useEffect(() => {
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }
    axios
      .post(
        "https://admin-node-api.amanueltesfaye55.workers.dev/admin/auth/verify",
        {},
      )
      .then((res) => {
        sessionStorage.setItem("jwt", res.data.token);
        navigate("/dashboard", { replace: true });
      });
  }, [token, navigate]);
  return (
    <form onSubmit={requestLogin}>
      <section class="logo-section ">
        <section>
          <h2 id="form-log">Admin Panel Login</h2>
        </section>
        <div class="logo-container">
          <img
            src="https://pub-a3772f2b02704b91829728f4cc7bbe15.r2.dev/logo(new).svg"
            id="login-logo"
            alt="login-logo"
          />
        </div>
      </section>
      <input
        type="password"
        placeholder="Enter your username"
        onInput={handleChange}
        id="passwordInput"
        name="name"
      ></input>
      <label for="show_password">
        <input type="checkbox" id="show_password" onInput={togglePassword} />{" "}
        Show Content
      </label>
      <button id="submit-btn" type="submit" className="btn">
        Request
      </button>
    </form>
  );
}
